import React from 'react';
import BaseProps from "../types/BaseProps";
import classNames from "classnames";
import Icon from "./Icon";

type ExternalLinkProps = BaseProps & {
  href: string,
  target?: string,
  children?: any
};

/**
 * Simple component for rendering a link element with external link icon.
 *
 * If no children are given, the component will render the link as text.
 */
export function ExternalLink(props: ExternalLinkProps) {
  const classes = classNames(props.className);
  const target = props.target || "_blank";
  return (
    <a href={props.href} target={target} className={classes} rel="noopener noreferrer">
      {props.children || props.href}
      <sup>
        <Icon className="ExternalLinkIcon pl-1" icon={['fas', 'external-link-alt']}/>
      </sup>
    </a>
  );
}
